export default __webpack_public_path__ + "static/media/prev_icon.7822a1fb.svg";